import capitalize from 'shared/utils/capitalize';

export default (title: string, defaultTitle = '[No title]'): void => {
  document.title = `${title !== '' ? capitalize(title) : defaultTitle} | Readwise`;
};
